import { Component, ElementRef, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import {
	EVENT_EMITTERS,
	SEM_CALLS_SOURCE,
	HIGHCHARTS_LEGEND_VERTICAL_ALIGN
} from '../../../analytics/constants/analytics.constants';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { Observable, forkJoin } from 'rxjs';
import * as moment from 'moment';
import * as Highcharts from 'highcharts';
import * as numeral from 'numeral';
import { GraphDataModel } from '../daily-stats/daily-stats.component';
import * as _ from 'underscore';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ChartConfig, GraphConfig } from '../../../analytics-core/interfaces/chart.interface';
import { CallGraph, CallKeyword } from '../../../analytics-core/interfaces/sem-calls.interface';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import * as jQuery from 'jquery';

@Component({
	selector: 'app-sem-calls-v1',
	templateUrl: './sem-calls-v1.component.html',
	styleUrls: ['./sem-calls-v1.component.css']
})
export class SemCallsV1Component implements OnInit, WidgetCore, OnDestroy {
	@ViewChild('graphArea') graphElement: ElementRef;
	public SEM_CALLS_SOURCE = SEM_CALLS_SOURCE;

	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() timeserieskey: string;
	@Input() tertiarykey: string;
	@Input() colors: string;
	@Input() groupby: string;
	@Input() colorsconfig: any;
	@Input() downloadconfig: string;
	@Input() downloadcsvcolumns: any;
	@Input() placeholderimage: any;
	@Input() chartconfiguration: any;

	public colorPalette: ColorPalette;
	public avgDuration: number;
	public barChart: any;
	public callsCount: number;
	public callsRecieved: number;
	public callsMissed: number;
	public downloadConfiguration: DownloadConfig;
	public graphData: CallGraph[] = [];
	public hasData: boolean;
	public keywordsData: CallKeyword[] = [];
	public reloadSubscription;
	public showLoad = false;
	public isR104: boolean = false;
	public widgetDataSubscription;
	protected chartConfig: ChartConfig;
	protected defaultCount = 8;
	protected graphObj: GraphDataModel = <GraphDataModel>{};

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit() {
		this.isR104 = this.analyticsDataModel.config.directoryName === 'default-r104' ? true : false;
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.chartConfig = JSON.parse(decodeURI(this.chartconfiguration));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		if (this.chartConfig.seriesConfig) {
			this.barChart = this.chartConfig.seriesConfig[0];
		}
		this.downloadcsvcolumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.requestData();
	}

	ngAfterViewChecked(): void {
		//Called after every check of the component's view. Applies to components only.
		//Add 'implements AfterViewChecked' to the class.
		// need to re work on this logic
		if (this.analyticsDataModel.config.version.toLowerCase() == 'r7') {
			jQuery('.custom-primary').addClass('r7_primary_bg_color');
		}
	}

	ngOnDestroy() {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData() {
		this.hasData = true;
		this.showLoad = true;
		this.analyticsService.processCustomServiceRequest(this.key).subscribe((responses: any) => {
			if (responses.success) {
				this.graphData = this.mapCallGraphDataToInterface(responses.data.calls_graph_data);
				this.avgDuration = Math.round(
					UtilityService.isUndefinedOrNull(responses.data.calls_avg_data[0].avg_duration_in_minutes)
						? 0
						: Number(responses.data.calls_avg_data[0].avg_duration_in_minutes)
				);
				this.callsCount = UtilityService.isUndefinedOrNull(responses.data.calls_avg_data[0].calls)
					? 0
					: Number(responses.data.calls_avg_data[0].calls);
				if (this.graphData.length > 0) {
					this.hasData = true;
					setTimeout(() => {
						this.generateGraphData(this.graphData);
						setTimeout(() => {
							this.drawGraph();
						});
					}, 100);
				} else {
					this.hasData = false;
				}
			} else {
				this.hasData = false;
			}
			if (responses.success) {
				if (responses.data.top_keywords_data.length > 0) {
					this.hasData = true;
				}
				this.keywordsData = this.mapCallKeywordDataToInterface(responses.data.top_keywords_data);
			} else {
				this.hasData = false;
			}
			this.processResponseData();
			this.showLoad = false;
		});
	}

	processResponseData() {}

	drawGraph() {
		const self = this;
		Highcharts.chart({
			chart: {
				renderTo: this.graphElement.nativeElement,
				margin: this.chartConfig.graphConfig.margin,
				height: '470px'
			},
			title: {
				text: null
			},
			subtitle: {
				text: null
			},
			xAxis: {
				categories: this.graphObj.categories,
				labels: {
					step: this.graphObj.stepCount,
					formatter: function () {
						return moment(this.value).format('D-MMM');
					}
				}
			},
			tooltip: {
				shared: false,
				useHTML: true,
				borderColor:
					this.chartConfig.seriesConfig[0].tooltipInfo[0] && this.chartConfig.seriesConfig[0].tooltipInfo[0].borderColor
						? this.chartConfig.seriesConfig[0].tooltipInfo[0].borderColor
						: '',
				backgroundColor:
					this.chartConfig.seriesConfig[0].tooltipInfo[0] &&
					this.chartConfig.seriesConfig[0].tooltipInfo[0].backgroundColor
						? this.chartConfig.seriesConfig[0].tooltipInfo[0].backgroundColor
						: 'rgba(247,247,247,0.85)',
				borderRadius: this.chartConfig.seriesConfig[0].tooltipInfo[0].borderRadius,
				formatter: function () {
					if (
						self.chartConfig.seriesConfig[0].tooltipInfo[0] &&
						self.chartConfig.seriesConfig[0].tooltipInfo[0].newTooltip
					) {
						return (
							'<div style="text-align:center">' +
							this.point['toolTipData'] +
							' ' +
							moment(this.x).format('MM/DD/YY') +
							'</div>'
						);
					}
					if (this.point['toolTipData']) {
						return this.x + '<br/>' + this.point['toolTipData'];
					}
					return this.x + '<br/>' + this.point.y;
				}
			},
			yAxis: [
				{
					// Primary yAxis
					title: {
						text: 'Calls'
					},
					gridLineDashStyle: 'LongDash',
					gridLineWidth: 0,
					allowDecimals: false
				},
				{
					// Secondary yAxis
					title: {
						text: this.chartConfig.graphConfig.secondaryYAxis.title['text']
					},
					labels: {
						formatter: function () {
							if (Number(this.value) % 1 != 0) {
								return parseFloat(String(this.value)).toFixed(2);
							}
							return String(this.value);
						}
					},
					allowDecimals: false,
					opposite: true,
					gridLineWidth:
						this.chartConfig &&
						this.chartConfig.graphConfig &&
						this.chartConfig.graphConfig.secondaryYAxis.gridLineWidth
							? Number(this.chartConfig.graphConfig.secondaryYAxis.gridLineWidth)
							: null,
					gridLineDashStyle: 'Solid'
				}
			],
			credits: {
				enabled: false
			},
			plotOptions: {
				column: {
					stacking: 'normal',
					borderRadius: this.barChart && this.barChart.borderRadius ? this.barChart.borderRadius : 0
				},
				series: {
					borderWidth: 0,
					lineWidth: this.barChart && this.barChart.lineWidth ? this.barChart.lineWidth : 3
				}
			},
			legend: {
				layout: 'horizontal',
				align: 'center',
				verticalAlign:
					HIGHCHARTS_LEGEND_VERTICAL_ALIGN[this.chartConfig.graphConfig.legendConfig.verticalAlign] || 'bottom',
				floating: false,
				symbolPadding: 5,
				itemWidth: 180,
				symbolRadius:
					this.chartConfig.seriesConfig[0].marker && this.chartConfig.seriesConfig[0].marker.symbolRadius
						? this.chartConfig.seriesConfig[0].marker.symbolRadius
						: 12,
				x: 0,
				y: 0
			},
			series: this.graphObj.series
		});
	}

	generateGraphData(graphData) {
		this.graphObj.graphTitle = '';
		this.graphObj.graphSubTitle = '';
		this.graphObj.xAxisLabel = '';
		this.graphObj.yAxisLabelLeft = '';
		this.graphObj.yAxisLabelRight = '';
		this.graphObj.series = this.buildChartSeriesObj(graphData);
		this.graphObj.categories = this.buildCategoriesObj(graphData);
		this.graphObj.stepCount = this.calculateStepCount(this.graphObj.categories.length);
	}

	protected buildChartSeriesObj(graphData) {
		const chartSeries: any = [];
		const totalDuration = _.pluck(graphData, 'totalDuration');
		const avgDuration = _.pluck(graphData, 'avgDuration');
		const noOfCalls = _.pluck(graphData, 'noOfCalls');
		const totalDataLength = noOfCalls.length;

		const avgDurationObj: any = {};
		const avgDurationSeriesInfo = [
			{
				name: this.chartConfig.graphConfig.secondaryYAxis.title['text'],
				data: avgDuration,
				isSeriesData: true
			}
		];

		avgDurationObj.type = this.chartConfig.seriesConfig[1].type;
		avgDurationObj.name = this.chartConfig.graphConfig.secondaryYAxis.title['text'];
		avgDurationObj.data = this.buildSeriesWithToolTipInfo(avgDurationSeriesInfo, totalDataLength);
		avgDurationObj.color = this.getColorFromColorConfig(1, 1);
		avgDurationObj.fillOpacity = this.chartConfig.seriesConfig[1].fillOpacity;
		avgDurationObj.yAxis = 1;
		avgDurationObj.opposite = true;
		avgDurationObj.legendIndex = this.chartConfig.seriesConfig[1].legendIndex;
		avgDurationObj.maxPointWidth = 50;
		avgDurationObj.zIndex = 1;
		avgDurationObj.marker = {
			symbol: this.chartConfig.seriesConfig[1].marker.symbol,
			enabled: this.chartConfig.seriesConfig[1].marker.enabled
		};
		const noOfCallsObj: any = {};
		const noOfCallsSeriesInfo = [
			{
				name: 'Calls',
				data: noOfCalls,
				isSeriesData: true
			}
		];
		noOfCallsObj.type = 'column';
		noOfCallsObj.name = 'Calls';
		noOfCallsObj.color = this.barChart.colorConfig.isHex
			? this.barChart.colorConfig.color
			: this.getColorFromColorConfig(0, 1);
		noOfCallsObj.data = this.buildSeriesWithToolTipInfo(noOfCallsSeriesInfo, totalDataLength);
		noOfCallsObj.fillOpacity = 0.4;
		noOfCallsObj.legendIndex = this.chartConfig.seriesConfig[0].legendIndex;
		noOfCallsObj.marker = {
			symbol: this.chartConfig.seriesConfig[0].marker.symbol
		};

		chartSeries.push(avgDurationObj);
		chartSeries.push(noOfCallsObj);
		return chartSeries;
	}

	protected buildCategoriesObj(data) {
		const dates = _.pluck(data, 'date');
		return dates;
	}

	protected isFloat(n) {
		return Number(n) === n && n % 1 !== 0;
	}

	dynamicWidth() {
		(function (H) {
			const each = H.each;
			H.wrap(H['seriesTypes'].column.prototype, 'drawPoints', function (proceed) {
				const series = this;
				if (series.data.length > 0) {
					const width = series.barW > series.options.maxPointWidth ? series.options.maxPointWidth : series.barW;
					each(this.data, function (point) {
						point.shapeArgs.x += (point.shapeArgs.width - width) / 2;
						point.shapeArgs.width = width;
					});
				}
				proceed.call(this);
			});
		})(Highcharts);
	}

	protected calculateStepCount(dataLength) {
		if (dataLength <= this.defaultCount) {
			return 1;
		}
		return Math.ceil(dataLength / (this.defaultCount * 2));
	}

	buildSeriesWithToolTipInfo(infoObj: any, totalDataLength: number) {
		const seriesData = [];
		for (let i = 0; i < totalDataLength; i++) {
			const tempObj: any = {};
			let toolTipHTML = '';
			for (const info of infoObj) {
				if (info.isSeriesData) {
					tempObj.y = info.data[i];
				}
				const value = info.data[i];
				if (
					this.chartConfig.seriesConfig &&
					this.chartConfig.seriesConfig[0].tooltipInfo &&
					this.chartConfig.seriesConfig[0].tooltipInfo[0] &&
					this.chartConfig.seriesConfig[0].tooltipInfo[0].newTooltip
				) {
					toolTipHTML +=
						'<p>' +
						info.name +
						'<br/><b>' +
						(this.isFloat(value) ? numeral(value).format('0,0.00') + '%' : numeral(value).format('0,0')) +
						'</b></p>';
				} else {
					toolTipHTML +=
						'<div>' +
						info.name +
						' : ' +
						(this.isFloat(value) ? numeral(value).format('0,0.00') + '%' : numeral(value).format('0,0')) +
						'</div><br/>';
				}
			}
			tempObj.toolTipData = toolTipHTML;
			seriesData.push(tempObj);
		}
		return seriesData;
	}

	mapCallGraphDataToInterface(responseArray: any[]) {
		const callsData: CallGraph[] = [];
		for (const response of responseArray) {
			const callGraphData: CallGraph = <CallGraph>{};
			callGraphData.date = moment(response.date).format('MM/DD/YYYY');
			callGraphData.avgDuration = Math.round(parseFloat(response.avg_duration));
			callGraphData.missed = !UtilityService.isUndefinedOrNull(response.call_missed_count)
				? Math.round(parseFloat(response.call_missed_count))
				: 0;
			callGraphData.oneThirtySecond = !UtilityService.isUndefinedOrNull(response['1_30_seconds'])
				? Math.round(parseFloat(response['1_30_seconds']))
				: 0;
			callGraphData.thirtySixtySecond = !UtilityService.isUndefinedOrNull(response['30_60_seconds'])
				? Math.round(parseFloat(response['30_60_seconds']))
				: 0;
			callGraphData.greaterSixtySecond = !UtilityService.isUndefinedOrNull(response.greater_than_60_seconds)
				? Math.round(parseFloat(response.greater_than_60_seconds))
				: 0;
			callGraphData.totalDuration = Math.round(parseFloat(response.total_duration));
			callGraphData.noOfCalls = parseInt(response.no_of_calls);
			callsData.push(callGraphData);
		}
		return callsData;
	}

	mapCallKeywordDataToInterface(responseArray: any[]) {
		const keywordsData: CallKeyword[] = [];
		for (const response of responseArray) {
			const keywordObj: CallKeyword = <CallKeyword>{};
			keywordObj.data = parseFloat(response.data).toFixed(2);
			keywordObj.calls = parseInt(response.calls);
			keywordObj.source = response.source;
			keywordObj.keyword = response.name;
			keywordsData.push(keywordObj);
		}
		return keywordsData;
	}

	protected getColorFromColorConfig(index: number, opacity?: number) {
		const colorConfig: ColorConfig = this.colorsconfig[index];
		const fillOpacity = opacity ? opacity : colorConfig.opacity;
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}

	downloadCSV() {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadcsvcolumns
		);
	}
}
